import { render, staticRenderFns } from "./UserProfileNew.vue?vue&type=template&id=3a60827f"
import script from "./UserProfileNew.vue?vue&type=script&lang=js"
export * from "./UserProfileNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports